import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { getRRSSAudience } from '../../../utils/apiMiniWidget';
import { StyledWrapper } from './style';
import { API_RRSS_DOWNLOAD } from '../../../constants/api';
import { navigateToFile } from '../../../utils/navigate';
import { RRSSAudienceDate } from '../../views/RRSSAudienceDate';

const RRSSAudience = () => {
  const [data, setData] = useState(undefined);

  useEffect(() => {
    getRRSSAudience()
      .then(digitalAudienceData => {
        setData(digitalAudienceData);
      })
      .catch(error => {
        console.error('Error desde DigitalAudience', error);
      });
  }, []);

  const downloadButton = () => {
    if (data && data.length >= 1) {
      navigateToFile(`${API_RRSS_DOWNLOAD}${data[0].clientPath}`);
    }
  };

  let publishDate;
  let otherTitle;
  if (data && data.length > 0) {
    publishDate = moment(data[0].publishDate);
    otherTitle = data[0].title;
  }
  return (
    <StyledWrapper>
      {data && data.length > 0 && (
        <RRSSAudienceDate
          dayWeek={publishDate.format('ddd')}
          numberWeek={publishDate.format('DD')}
          text={otherTitle}
          onClick={downloadButton}
        />
      )}
    </StyledWrapper>
  );
};

export default RRSSAudience;
